<template>
    <div style="display: block;">
        <div v-if="props.question.text != null" class="row mb-2">
            <div class="col">{{ props.question.text[participant.language] }}</div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="input-group">
                    <select 
                        class="form-select" 
                        :name="props.question.variable"
                        @input="event => updateHeight('feet', event, response)"
                    >
                        <option value>Select ...</option>
                        <option v-for="option in props.question.select[0].options" 
                                :value="option.value"
                                :selected="calculateFeet(response) === option.value"
                                :key="option.value"
                        >
                            {{ option.label[participant.language] }}
                        </option>
                    </select>
                    <span class="input-group-text">{{ props.question.unit[0][participant.language] }}</span>
                </div>
            </div>
            <div class="col-6">
                <div class="input-group">
                    <select 
                        class="form-select" 
                        :name="props.question.variable"
                        @input="event => updateHeight('inches', event, response)"
                    >
                        <option value>Select ...</option>
                        <option v-for="option in props.question.select[1].options" 
                                :value="option.value"
                                :selected="calculateInches(response) === option.value"
                                :key="option.value"
                        >
                            {{ option.label[participant.language] }}
                        </option>
                    </select>
                    <span class="input-group-text">{{ props.question.unit[1][participant.language] }}</span>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { ref } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'
    import debounce from "lodash/debounce"

    const { saveResponse, setError } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    function calculateFeet(response) {
        if (response[props.question.variable] == null) {
            return null
        } else if ([888, 999].includes(response[props.question.variable])) {
            return response[props.question.variable]
        } else {
            return Math.floor(response[props.question.variable]/12)
        }
    }

    function calculateInches(response) {
        if (response[props.question.variable] == null) {
            return null
        } else if ([888, 999].includes(response[props.question.variable])) {
            return response[props.question.variable]
        } else {
            if (response[props.question.variable] >= 12) {
                return response[props.question.variable] % 12
            } else {
                return response[props.question.variable]
            }
        }
    }

    function updateHeight(unit, event, response) {
        if (['888', '999'].includes(event.target.value)) {
            response[props.question.variable] = event.target.value
            saveResponse()
            return
        }

        let oldTotalInches = response[props.question.variable] ?? 0
        let oldFeet = Math.floor(oldTotalInches/12)
        let oldInches = oldTotalInches % 12

        if (unit == 'feet') {
            if (event.target.value > oldFeet) {
                response[props.question.variable] = oldTotalInches + ((event.target.value - oldFeet) * 12)
            }
            if (oldFeet > event.target.value) {
                response[props.question.variable] = oldTotalInches - ((oldFeet - event.target.value) * 12)
            }
        }
        if (unit == 'inches') {
            response[props.question.variable] = (oldFeet * 12) + parseInt(event.target.value)
        }

        setError('')
        if (response[props.question.variable] < 24) {
            setError('Please enter a height of at least 2 ft.')
            return
        }

        saveResponse()
    }
</script>